export const configs = {
  API_URL: process.env.API_URL || 'http://localhost:3000',
  SERVICE_URL: process.env.SERVICE_URL || 'http://localhost:8080',
  ENV: process.env.NODE_ENV || 'development',
  VERSION: process.env.VERSION || '1',
  TOSS_CLIENT_KEY: process.env.TOSS_CLIENT_KEY || 'live_ck_dP9BRQmyarYOMWY45pX3J07KzLNk',
};

export const IS_PRODUCTION = process.env.NODE_ENV === 'production';
